import { Head, Link } from "@inertiajs/react";
import { Box, Button, Stack } from "@mantine/core";
import AppShell from "../../Components/Layout/AppShell";
import PostDetail from "../PostDetail";
import { Heading1, DimmedText } from "../../Components/UI/Typography";
import { getPostBySlug } from "../../data/posts";

interface Props {
  slug: string;
}

/**
 * Route wrapper for /think/:slug — looks up the Post by (pillar='think', slug)
 * from the unified posts.ts data and delegates rendering to the universal
 * PostDetail page. If the post doesn't exist, renders a not-found fallback.
 */
export default function ThinkShow({ slug }: Props) {
  const post = getPostBySlug("think", slug);

  if (!post) {
    return (
      <AppShell>
        <Head>
          <title>Post Not Found | Ogarocious</title>
        </Head>
        <Box
          style={{
            minHeight: "100vh",
            background:
              "linear-gradient(180deg, #0a0705 0%, #0f0b08 50%, #0a0705 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Stack align="center" gap="md">
            <Heading1>Post Not Found</Heading1>
            <DimmedText>
              That post doesn&apos;t exist or has been removed.
            </DimmedText>
            <Button variant="gradient" component={Link} href="/think">
              Back to Think
            </Button>
          </Stack>
        </Box>
      </AppShell>
    );
  }

  return <PostDetail post={post} />;
}
